import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniCardComponent } from './mini-card/mini-card.component';
import { MainDashboardComponent } from './main-dashboard.component';
import { ChartCardComponent } from './chart-card/chart-card.component';
import { TableCardComponent } from './table-card/table-card.component';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { AgGridModule } from "@ag-grid-community/angular"
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { MiniCardConfigurationComponent } from './mini-card/mini-card-configuration/mini-card-configuration.component';
import { SharedModule } from 'src/app/shared-module/shared-module.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartCardConfigurationComponent } from './chart-card/chart-card-configuration/chart-card-configuration.component';
import { TableCardConfigurationComponent } from './table-card/table-card-configuration/table-card-configuration.component';
import { DahsBoardFilterConfigurationComponent } from './dashboard-filter-configurator/dashboard-filter-configurator.component';
import { DynamicFormsModule } from 'src/app/dynamic-forms/dynamic-forms.module';
import { TranslateModule } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AllCommunityModule, ModuleRegistry as mr } from 'ag-charts-community';
import { AgChartsModule } from 'ag-charts-angular';
import { GridsterAutoResizeDirective } from './gridster-auto-resize.directive';

ModuleRegistry.registerModules([
  CsvExportModule,
  ClientSideRowModelModule
]);

mr.registerModules([AllCommunityModule]);

/*
 * 100% NG-ZORRO + tokens --tem-*.
 * Demais módulos Nz (Button, Icon, Input, Divider, Tooltip, DropDown,
 * FloatButton, Select, Switch, Table, Grid) chegam via SharedModule.
 */
@NgModule({
  declarations: [
    MainDashboardComponent,
    MiniCardComponent,
    ChartCardComponent,
    ChartCardConfigurationComponent,
    TableCardComponent,
    MiniCardConfigurationComponent,
    TableCardConfigurationComponent,
    DahsBoardFilterConfigurationComponent,
    GridsterAutoResizeDirective
  ],
  imports: [
    AgChartsModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    AgGridModule,
    GridsterModule,
    SharedModule,
    TranslateModule,
    DynamicFormsModule,
    NzLayoutModule,
    NzTabsModule,
    NzCollapseModule,
    NzModalModule,
    NzFormModule,
    NzSpinModule
  ],
  exports: [
    MainDashboardComponent
  ],
  providers: []
})

export class MainDashboardModule {

}
